import {assert} from 'Asserts';
import {TableColumnProvenanceUuid} from 'notebook/structured-tables/structured-table-mappings/StructuredTableMappingConstants';

/** Creates a combined uuid for a column with its table's uuid. This is just used for easily identifying
 * on the frontend with maps. */
export default function makeTableColumnProvenanceUuid(
  structuredTableUuid: string,
  structuredTableColumnUuid: string
): TableColumnProvenanceUuid {
  return `${structuredTableUuid}|${structuredTableColumnUuid}`;
}

/** Parses the table column uuid into its separate table and column provenance uuids */
export function parseTableColumnProvenanceUuid(
  tableColumnProvenanceUuid: TableColumnProvenanceUuid
): [tableProvenanceUuid: string, columnProvenanceUuid: string] {
  const splitProvenanceUuids = tableColumnProvenanceUuid.split('|');
  assert(
    splitProvenanceUuids.length === 2 && splitProvenanceUuids.every((uuid) => uuid),
    'provided table column provenance uuid was not able to be parsed correctly'
  );
  return splitProvenanceUuids as [tableProvenanceUuid: string, columnProvenanceUuid: string];
}
